import { API, APIState, PlayedTile, Result, is_ok } from "./api";
import { WasmAPI as RawAPI } from "word_grid";
import { AI } from "./ws_api";

export class WasmAPI implements API {
    private wasm: RawAPI;

    constructor(seed: bigint, dictionary_text: string, ais: AI[]) {
        this.wasm = new RawAPI(seed, dictionary_text, ais);
    }

    add_to_dictionary(word: string): Promise<APIState> {
        return new Promise((resolve, reject) => {
            let api_state: Result<APIState, any> =
                this.wasm.add_to_dictionary(word);

            if (is_ok(api_state)) {
                resolve(api_state.Ok);
            } else {
                reject(api_state.Err);
            }
        });
    }

    exchange(selection: Array<boolean>): Promise<APIState> {
        return new Promise((resolve, reject) => {
            let api_state: Result<APIState, any> =
                this.wasm.exchange(selection);

            if (is_ok(api_state)) {
                resolve(api_state.Ok);
            } else {
                reject(api_state.Err);
            }
        });
    }

    load(_wait: boolean): Promise<APIState> {
        return new Promise((resolve, reject) => {
            let api_state: Result<APIState, any> = this.wasm.load();

            if (is_ok(api_state)) {
                resolve(api_state.Ok);
            } else {
                reject(api_state.Err);
            }
        });
    }

    pass(): Promise<APIState> {
        return new Promise((resolve, reject) => {
            let api_state: Result<APIState, any> = this.wasm.pass();

            if (is_ok(api_state)) {
                resolve(api_state.Ok);
            } else {
                reject(api_state.Err);
            }
        });
    }

    play(tiles: Array<PlayedTile>, commit: boolean): Promise<APIState> {
        return new Promise((resolve, reject) => {
            let api_state: Result<APIState, any> = this.wasm.play(
                tiles,
                commit,
            );

            if (is_ok(api_state)) {
                resolve(api_state.Ok);
            } else {
                reject(api_state.Err);
            }
        });
    }
}
